import React, { PureComponent } from "react";

import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";

import { Accordion, Button, ButtonGroup, Dropdown, Icon } from "aible";

import styles from "./style.module.css";

export default class BaselineCosts extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isBaseline: props.baseline === true ? true : false };
  }

  render() {
    const {
      setup,
      updateBaselineConversionGain,
      updateBaselineConversionCost,
      updateBaselineConversionMissed,
      updateBaselineConversionSaved,
      updateBaselineCustomValue,
      removeBaselineCustomValues
    } = this.props;

    const { isBaseline } = this.state;

    const hasBaseline =
      isBaseline ||
      setup.baselineConversionGain !== undefined ||
      setup.baselineConversionCost !== undefined ||
      setup.baselineConversionSaved !== undefined ||
      setup.baselineConversionMissed !== undefined;

    const isCustomValues = setup && setup.customValues && Object.keys(setup.customValues).length > 0;

    return (
      <div className={styles.projectHelpWrapper}>
        <a
          onClick={() => {
            if (isBaseline) {
              if (isCustomValues) {
                removeBaselineCustomValues(setup.blueprintId);
              } else {
                setup.baselineConversionGain !== undefined && updateBaselineConversionGain(undefined);
                setup.baselineConversionCost !== undefined && updateBaselineConversionCost(undefined);
                setup.baselineConversionSaved !== undefined && updateBaselineConversionSaved(undefined);
                setup.baselineConversionMissed !== undefined && updateBaselineConversionMissed(undefined);
              }
            }
            this.setState({ isBaseline: !isBaseline });
          }}
          style={{
            marginBottom: isBaseline ? "0px" : "20px",
            display: "block"
          }}
        >
          {/*isBaseline ? "Remove Baseline Costs" : "Set Baseline Costs"*/}
        </a>
        {isCustomValues ? (
          <div className={styles.hideBaselines} style={{ maxHeight: isBaseline ? "500px" : "0px" }}>
            {Object.keys(setup.customValues).map((v) => (
              <div className={styles.baselineInput} style={{ marginTop: "20px" }} key={"Baseline " + v}>
                <LineInput
                  isMediumBox
                  labelStyle={{ color: "#4B495B" }}
                  topLabel={"Baseline " + v}
                  value={
                    setup && setup.baselineCustomValues && setup.baselineCustomValues[v] !== undefined
                      ? setup.baselineCustomValues[v]
                      : setup.customValues[v]
                  }
                  onChange={(val) => updateBaselineCustomValue(setup.blueprintId, v, val)}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.hideBaselines} style={{ maxHeight: isBaseline ? "500px" : "0px" }}>
            <div className={styles.baselineInput} style={{ marginTop: "20px" }}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"Baseline True Positive"}
                value={setup.baselineConversionGain !== undefined ? setup.baselineConversionGain : setup.conversionGain}
                onChange={(val) => updateBaselineConversionGain(val)}
              />
            </div>
            <div className={styles.baselineInput}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"Baseline False Positive"}
                value={setup.baselineConversionCost !== undefined ? setup.baselineConversionCost : setup.conversionCost}
                onChange={(val) => updateBaselineConversionCost(val)}
              />
            </div>
            <div className={styles.baselineInput}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"Baseline True Negative"}
                value={
                  setup.baselineConversionSaved !== undefined ? setup.baselineConversionSaved : setup.conversionSaved
                }
                onChange={(val) => updateBaselineConversionSaved(val)}
              />
            </div>
            <div className={styles.baselineInput}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"Baseline False Negative"}
                value={
                  setup.baselineConversionMissed !== undefined ? setup.baselineConversionMissed : setup.conversionMissed
                }
                onChange={(val) => updateBaselineConversionMissed(val)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
